export function getBaseUrl(): string {
  if (BUILD_CONFIG.isElectron) {
    return BUILD_CONFIG.serverUrlPrefix;
  }
  if (typeof window === 'undefined') {
    // is nodejs
    return '';
  }
  const { protocol, hostname, port } = window.location;
  return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
}
